import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postjavascript2 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "JavaScript Functions and Scope",
      date: "October 1, 2023",
      image: "/assets/FeedItems/BBW9wYFE5aKngj2p85C.svg",
      summary: "Understand the basics of JavaScript functions and scope. Learn about defining functions, function parameters and return values, scope, and closures.",
      path: "blog/technology/javascript/post/postjavascript2"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "JavaScript Functions and Scope",
    date: "October 1, 2023",
    image: "/assets/FeedItems/BBW9wYFE5aKngj2p85C.svg",
    summary: "Understand the basics of JavaScript functions and scope. Learn about defining functions, function parameters and return values, scope, and closures.",
    path: "blog/technology/javascript/post/postjavascript2"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          Functions are one of the fundamental building blocks of JavaScript. They allow you to encapsulate code into reusable blocks, making your code more modular and maintainable. Understanding scope is also crucial for writing effective JavaScript code.
        </p>
        <h2>Defining Functions</h2>
        <p>
          In JavaScript, functions can be defined using function declarations or function expressions. A function declaration defines a named function, while a function expression defines a function as part of a larger expression.
        </p>
        <h2>Function Parameters and Return Values</h2>
        <p>
          Functions can accept parameters, which are values passed to the function when it is called. Functions can also return values using the return statement. Understanding how to work with parameters and return values is essential for writing effective functions.
        </p>
        <h2>Scope and Closures</h2>
        <p>
          Scope determines the visibility of variables within your code. JavaScript has function scope and block scope. Closures are a powerful feature of JavaScript that allow functions to access variables from an outer function even after the outer function has returned.
        </p>
        <p>
          Understanding functions and scope is essential for writing effective and maintainable JavaScript code. By mastering these concepts, you can create modular and reusable code that is easier to understand and maintain.
        </p>
      </div>
    </div>
  );
};

export default Postjavascript2;